export default "__VITE_ASSET__DHxBX06N__"